import { patchSangjoComparisonsDetail } from "@/apis/sangjoQuotation";
import { isLoggedInState } from "@/atoms/accountState";
import { temporaryMatchRequestState } from "@/containers/MatchContainer/atoms";
import { matchRequestCompareLoadingState } from "@/atoms/match/matchRequestLoadingState";
import { matchRequestResDataState } from "@/atoms/match/matchRequestResDataState";
import { sangjoComparisonIdState } from "@/containers/MatchContainer/remotes/atoms/sangjoComparisonState";
import { SangjoCompareRequestProps } from "@/containers/MatchContainer/type/requestType";
import { useDialog } from "@/hooks/useDialog";
import { useSangjoQuotationRequestExistModal } from "@/hooks/useSangjoQuotationRequestExistModal";
import { Box, Select } from "@chakra-ui/react";
import {
  상조비교_선불제상조업체LIST,
  상조비교_선불제상조여부,
} from "containers/MatchContainer/constants/request";
import {
  ColorIcon,
  colors,
  cooKeys,
  customEvent,
  Field,
  Radio,
  setCookie,
  Spacing,
  VStack,
} from "goi_common";
import { useRouter } from "next/router";
import { useCallback, useLayoutEffect, useMemo, useReducer, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import RequestCompareSubmitButton from "./RequestCompareSubmitButton";

function SangjoCompareQuotationRequest() {
  const router = useRouter();
  const sangjoComparisonId = useRecoilValue(sangjoComparisonIdState);
  const matchRequestResponse = useRecoilValue<any>(matchRequestResDataState);

  const isLoggedIn = useRecoilValue(isLoggedInState);
  const [isPrepaidFromOptions, setIsPrepaidFromOptions] = useState(true);
  const { onOpen, onClose } = useDialog();

  const [SelectedOption, setSelectedOption] = useReducer(
    (prev: SangjoCompareRequestProps, next: any) => {
      return { ...prev, ...next };
    },
    {
      선불제상조여부: "",
      상조회사이름: "",
    },
  );

  const { onOpenRequestExistModal } = useSangjoQuotationRequestExistModal();

  const isPrepaid = useMemo(() => {
    return SelectedOption.선불제상조여부 === "선불제 상조에 가입한 상태에요";
  }, [SelectedOption]);
  const isDisabled = useMemo(() => {
    return !SelectedOption.선불제상조여부 || !SelectedOption.상조회사이름;
  }, [SelectedOption]);

  useLayoutEffect(() => {
    if (!sangjoComparisonId) {
      router.back();
    }
  });

  // const handleContinueCompare = async () => {
  //   try {

  //     const body = {
  //       initial_type: "상조 비교",
  //       status: SelectedOption.장례준비긴급도,
  //       funeral_sido: SelectedOption.sido,
  //       funeral_sigungu: SelectedOption.sigungu,
  //       needs_binso: SelectedOption.조문객수 === "0명(무빈소)" ? false : true,
  //       condolers:
  //         SelectedOption.조문객수 === "없음"
  //           ? ""
  //           : SelectedOption.조문객수 === "0명(무빈소)"
  //             ? "0명"
  //             : (SelectedOption.조문객수 as string),
  //     };

  //     const { data, status } = await postSangjoQuotationRequest(body);
  //     if (status === 201) {
  //       customEvent({
  //         newGtm: {
  //           action: "match_request_complete",
  //         },
  //         triggerHackle: true,
  //       });
  //       setTemporaryMatchRequest(data.id);
  //       setResponseData(data);

  //       router.push(
  //         `/match-compare/service/`,
  //       );

  //       // overlay.open(({ isOpen, close: onClose }) => {
  //       //   return (
  //       //     <OverlayModal
  //       //       onClose={onClose}
  //       //       isOpen={isOpen}
  //       //       modalContentStyle={{
  //       //         minWidth: "320px",
  //       //         overflow: "scroll",
  //       //       }}
  //       //       overlayModalContent={<CustomRequestModalContent onClose={onClose} />}
  //       //     />
  //       //   );
  //       // });
  //     }
  //   } catch (e) {
  //     console.log(e);
  //     setLoading(false);
  //   }

  // }
  const handleSubmit = useCallback(async () => {
    if (loading) return;

    // customEvent({
    //   newGtm: {
    //     path: "match_request",
    //     trigger_and_target: "submit_conversion",
    //   },
    //   hackle: { key: HackleEventName["견적 요청 제출 클릭"] },
    // });

    if (isDisabled) {
      onOpen({
        type: 1,
        closeOnOverlayClick: false,
        header: "응답하지 않은 항목이 있어요",
        children: <>다시 확인해주세요.</>,
        footerProps: {
          text: "확인",
          onClick: onClose,
        },
      });
      return;
    }
    // if (isNaN(SelectedOption.납입금액)) {
    //   alert("금액은 숫자로 입력해주세요");
    //   return;
    // }
    try {
      setLoading(true);

      const body = {
        is_prepaid: isPrepaid,
        company_name: SelectedOption.상조회사이름,
        // total_prepaid: isPrepaid ? Number(SelectedOption.납입금액) : null,
        // price: isPrepaid ? null : Number(SelectedOption.납입금액),
        // package_name: SelectedOption.비교상품이름,
        // reference: SelectedOption.상품안내,
      };
      if (sangjoComparisonId) {
        const { data, status } = await patchSangjoComparisonsDetail(sangjoComparisonId, body);
        if (status === 200) {
          customEvent({
            newGtm: {
              path: "match_compare_service",
              trigger_and_target: "submit_conversion",
            },
          });
          if (isLoggedIn) {
            router.push(
              `/match/request-complete?id=${matchRequestResponse.id}&sido=${matchRequestResponse.funeral_sido}&sigungu=${matchRequestResponse.funeral_sigungu}`,
            );
          } else {
            setTemporaryMatchRequest(data.id);
            setResponseData(data);

            setCookie(cooKeys.quotation_request, JSON.stringify(data));
            router
              .push(
                `/login?redirectTo=${encodeURIComponent("/match/request")}&event_from=uv_mtch_rqst`,
              )
              .then((res) => {
                setLoading(false);
                onClose();
              });
            setLoading(false);
          }
        }
      }
    } catch (e: any) {
      console.log(e);
      if (e.response.status === 409) {
        onOpenRequestExistModal();
      }
      setLoading(false);
    }
  }, [SelectedOption]);

  const [loading, setLoading] = useRecoilState(matchRequestCompareLoadingState);
  const setResponseData = useSetRecoilState<any>(matchRequestResDataState);

  // const overlay = useOverlay();

  const [, setTemporaryMatchRequest] = useRecoilState(temporaryMatchRequestState);
  return (
    <>
      <VStack padding="24px" width="100%">
        <Box
          width="100%"
          boxShadow="0px 0px 12px rgba(0, 0, 0, 0.12)"
          border={`1px solid ${colors.gray100}`}
          borderRadius="6px"
          background={colors.warmGray100}
          padding="16px"
          className="body3_r gray700"
        >
          앞서 응답하신 답변과 함께,
          <br />
          현재 가입하신 상조 서비스에 대해 알려주시면
          <br />
          한번에 비교하여 필요없는 품목, 주의할 점을 알려드려요.
        </Box>
        <Spacing gap={24} />

        <Field.ButtonGroups
          title="1. 비교하시는 상조가 선불제 상조인가요?"
          items={상조비교_선불제상조여부.map((t) => t.text)}
          value={SelectedOption.선불제상조여부}
          onChange={(e) => {
            setSelectedOption({ 선불제상조여부: e });
            customEvent({
              newGtm: {
                path: "match_compare_service",
                trigger_and_target: "is_prepaid_answer",
              },
            });
          }}
          buttonWidth="100%"
          flexDirection="column"
        />

        <Spacing gap={48} />
        {SelectedOption.선불제상조여부 && (
          <>
            <VStack gap="16px" position="relative">
              {isPrepaid && (
                <>
                  <Box className="subtitle2_sb gray900">
                    2. 선불제 상조 회사 이름을 선택해주세요
                    <br />
                    <span className="body_16_m gray700">(직접 입력 가능)</span>
                  </Box>
                  <Box>
                    <Radio
                      alignItem="center"
                      width="100%"
                      index={`prepaid_select`}
                      checked={isPrepaidFromOptions}
                      onClick={() => {
                        setIsPrepaidFromOptions(true);
                      }}
                      label={
                        <PrepaidOptions
                          onClick={() => {
                            setIsPrepaidFromOptions(true);
                          }}
                          values={상조비교_선불제상조업체LIST}
                          value={SelectedOption.상조회사이름}
                          onChange={(e: any) => {
                            setSelectedOption({ 상조회사이름: e.target.value });
                            customEvent({
                              newGtm: {
                                path: "match_compare_service",
                                trigger_and_target: "company_name-answer",
                              },
                            });
                          }}
                        />
                      }
                    />
                    <Spacing gap={24} />
                    <Radio
                      width="100%"
                      index={`prepaid_select_not`}
                      checked={!isPrepaidFromOptions}
                      onClick={() => {
                        if (isPrepaidFromOptions) {
                          setSelectedOption({ 상조회사이름: "" });
                        }
                        setIsPrepaidFromOptions(false);
                      }}
                      label={
                        <VStack>
                          <div className="body_16_m gray400">직접 입력 :</div>
                          <Field.Input
                            variant="outlined"
                            onFocus={() => {
                              if (isPrepaidFromOptions) {
                                setSelectedOption({ 상조회사이름: "" });
                              }
                              setIsPrepaidFromOptions(false);
                            }}
                            id="home-input"
                            value={isPrepaidFromOptions ? "" : SelectedOption.상조회사이름}
                            onChange={(v) => {
                              setSelectedOption({ 상조회사이름: v });
                              customEvent({
                                newGtm: {
                                  path: "match_compare_service",
                                  trigger_and_target: "company_name-answer",
                                },
                              });
                            }}
                            placeholder="상조 회사 이름을 입력해주세요"
                          />
                        </VStack>
                      }
                    />
                  </Box>
                </>
              )}

              {!isPrepaid && (
                <>
                  <Box className="subtitle2_sb gray900">
                    2. 후불제 상조 회사 이름을 입력해주세요
                  </Box>
                  <Field.Input
                    variant="outlined"
                    id="home-input"
                    value={SelectedOption.상조회사이름}
                    onChange={(v) => {
                      setSelectedOption({ 상조회사이름: v });
                      customEvent({
                        newGtm: {
                          path: "match_compare_service",
                          trigger_and_target: "company_name-answer",
                        },
                      });
                    }}
                    placeholder="예시: 고이장례연구소"
                  />
                </>
              )}
            </VStack>
            <Spacing gap={80} />
          </>
        )}

        <Spacing gap={108} />
      </VStack>

      <RequestCompareSubmitButton
        disabled={isDisabled}
        handleSubmit={handleSubmit}
        loading={loading}
      />
    </>
  );
}

export default SangjoCompareQuotationRequest;

const PrepaidOptions = ({
  values,
  value,
  onChange,
  onClick,
}: {
  values: string[];
  value: string;
  onChange: any;
  onClick: () => void;
}) => {
  return (
    <Box width="100%" onClick={onClick}>
      <Select
        height="44px"
        alignItems="center"
        border={`1px solid ${colors.gray200}`}
        borderRadius="3px"
        value={value}
        onChange={onChange}
        icon={
          <ColorIcon
            name="icon-arrow-right-small-mono"
            size={16}
            color={colors.gray900}
            css={{ transform: "rotateZ(90deg)" }}
          />
        }
      >
        {values.length > 0 ? (
          <>
            <option value={""} className="button_16_sb gray500 font-center">
              선택해주세요
            </option>
            {values.map((v: any) => {
              return (
                <option key={v} value={v} className="button_16_sb gray700 font-center">
                  {v}
                </option>
              );
            })}
          </>
        ) : (
          <option value={""}>선택해주세요</option>
        )}
      </Select>
    </Box>
  );
};
